module.exports = __webpack_public_path__ + "static/media/icon_close.82c1ebe9.svg";